import { render, staticRenderFns } from "./ModalImportClassVoucher.vue?vue&type=template&id=fbea6b58&scoped=true"
import script from "./ModalImportClassVoucher.vue?vue&type=script&lang=js"
export * from "./ModalImportClassVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbea6b58",
  null
  
)

export default component.exports